var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "55px",
    viewBox: "0 0 66 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Release---1.1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen-Documents-Upload",
    transform: "translate(-687.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-upload-cloud",
    transform: "translate(690.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "41 35 30 24 19 35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 24,
    x2: 29.5,
    y2: 49,
    id: "Path",
    stroke: "#80D4E8",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8903868,42 C58.3617034,39.0144706 61.1145182,32.6960489 59.5774297,26.6515077 C58.0403413,20.6069664 52.6045446,16.3746651 46.3729795,16.3705471 L42.9370243,16.3705471 C40.6766051,7.61945302 33.2629865,1.1669475 24.2907044,0.141565284 C15.3184223,-0.883816928 6.64242617,3.72991396 2.46932315,11.7457638 C-1.70377988,19.7616136 -0.511233246,29.5223677 5.46874988,36.2954679",
    id: "Path",
    stroke: "#0173C6",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#80D4E8",
    strokeWidth: 6,
    points: "41 35 30 24 19 35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationUploadCloud);
export default __webpack_public_path__ + "static/media/illustration-upload-cloud.5946235e.svg";
export { ForwardRef as ReactComponent };